import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { BACKEND_APIS } from "@constants"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { useToast } from "@hooks"

export default function useAutoEuropeEdit(id) {
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onEdit = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/list`, { id })
			.then(data => {
				autoEuropeDrawerData.value = data
				autoEuropeOriginalData.value = data
				isLoading.value = false
			})
			.catch(() => {
				isLoading.value = false
				showToast.error("Error loading AutoEurope pricing tool")
			})
	}, [id])

	return { onEdit, isLoading: isLoading.value }
}